var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCircleBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#E5EAED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 13H9.5V9H8.5V13ZM10.5 13H11.5V9H10.5V13ZM7.5 14H12.5V8H7.5V14ZM8.5 7H11.5V6H8.5V7ZM12.5 7V5H7.5V7H5V8H6.5V15H13.5V8H15V7H12.5Z",
    fill: "#A7BBCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCircleBg);
export default __webpack_public_path__ + "static/media/delete-circle-bg.bc3ef7349c0e8ce745f43cc91deb9ae4.svg";
export { ForwardRef as ReactComponent };